import { render, staticRenderFns } from "./TheQuestion.vue?vue&type=template&id=5f924912&scoped=true&"
import script from "./TheQuestion.vue?vue&type=script&lang=js&"
export * from "./TheQuestion.vue?vue&type=script&lang=js&"
import style0 from "./TheQuestion.vue?vue&type=style&index=0&id=5f924912&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f924912",
  null
  
)

export default component.exports